import { render, staticRenderFns } from "./VuelidateErrorTemplate.vue?vue&type=template&id=29142a8c"
import script from "./VuelidateErrorTemplate.vue?vue&type=script&lang=js"
export * from "./VuelidateErrorTemplate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/src/Companion.WebApp/ClientApp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('29142a8c')) {
      api.createRecord('29142a8c', component.options)
    } else {
      api.reload('29142a8c', component.options)
    }
    module.hot.accept("./VuelidateErrorTemplate.vue?vue&type=template&id=29142a8c", function () {
      api.rerender('29142a8c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/ui/VuelidateErrorTemplate.vue"
export default component.exports